import ROLE from "models/role";
import { INTERNAL_TEAM_ROUTES } from "definitions/constants/routeConstants";
import ListNewHireJourneysPage from "pages/PeopleTeam/NewHires/ListNewHireJourneysPage";
import NewHirePage from "pages/PeopleTeam/NewHires/NewHirePage";
import PendingNewHirePage from "pages/PeopleTeam/NewHires/PendingNewHirePage";
import { Route } from "./types";

// All roles — backend policy gates what each user can see;
// new hires (ONBOARDER) are redirected to the portal by NewHirePage itself.
const INTERNAL_TEAM_ROUTES_PERMISSIONS = {
  permission: Object.values(ROLE),
};

const PEOPLE_TEAM_ONLY_PERMISSIONS = {
  permission: [ROLE.PEOPLE_TEAM],
};

const SHARED_COMPANY_PENDING_NEW_HIRE_JOURNEYS_ROUTE: Route = {
  path: INTERNAL_TEAM_ROUTES.newHireJourneys.pending.index,
  title: "Pending New Hires",
  component: <ListNewHireJourneysPage />,
  ...PEOPLE_TEAM_ONLY_PERMISSIONS,
};

const SHARED_COMPANY_COMPLETED_NEW_HIRE_JOURNEYS_ROUTE: Route = {
  path: INTERNAL_TEAM_ROUTES.newHireJourneys.completed.index,
  title: "Completed New Hires",
  component: <ListNewHireJourneysPage />,
  ...PEOPLE_TEAM_ONLY_PERMISSIONS,
};

const SHARED_COMPANY_NEW_HIRE_JOURNEYS_ROUTE: Route = {
  path: INTERNAL_TEAM_ROUTES.newHireJourneys.index,
  title: "New Hires",
  component: <ListNewHireJourneysPage />,
  ...PEOPLE_TEAM_ONLY_PERMISSIONS,
};

const SHARED_COMPANY_PENDING_NEW_HIRE_JOURNEY_ROUTE: Route = {
  path: INTERNAL_TEAM_ROUTES.newHireJourneys.pending.show,
  title: "Pending New Hire",
  component: <PendingNewHirePage />,
  ...PEOPLE_TEAM_ONLY_PERMISSIONS,
};

const SHARED_COMPANY_NEW_HIRE_JOURNEY_ROUTE: Route = {
  path: INTERNAL_TEAM_ROUTES.newHires.showAll,
  title: "New Hire",
  component: <NewHirePage />,
  ...INTERNAL_TEAM_ROUTES_PERMISSIONS,
};

const SHARED_COMPANY_NEW_HIRE_JOURNEY_BASE_ROUTE: Route = {
  path: INTERNAL_TEAM_ROUTES.newHires.show,
  title: "New Hire",
  component: <NewHirePage />,
  ...INTERNAL_TEAM_ROUTES_PERMISSIONS,
};

export default [
  SHARED_COMPANY_PENDING_NEW_HIRE_JOURNEYS_ROUTE,
  SHARED_COMPANY_COMPLETED_NEW_HIRE_JOURNEYS_ROUTE,
  SHARED_COMPANY_NEW_HIRE_JOURNEYS_ROUTE,
  SHARED_COMPANY_PENDING_NEW_HIRE_JOURNEY_ROUTE,
  SHARED_COMPANY_NEW_HIRE_JOURNEY_ROUTE,
  SHARED_COMPANY_NEW_HIRE_JOURNEY_BASE_ROUTE,
];
